import React, { useRef } from "react";

import { useIntersectionObserver } from "@is/hooks";

type Props = {
  children: React.ReactNode;
  className?: string;
  onUpdate: () => void;
  onLastIntersectedItem?: (isIntersecting: boolean) => void;
  params?: IntersectionObserverInit;
};

const IntersectionObserver = ({
  children,
  className,
  onUpdate,
  onLastIntersectedItem,
  params,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useIntersectionObserver({
    elementRef: ref,
    onUpdate,
    onLastIntersectedItem,
    params,
  });

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};

export default IntersectionObserver;
